import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import { TbSquareRoundedPlusFilled } from 'react-icons/tb';
import AcademiaButton from '../CommonComps/Buttons/AcademiaButton';
import CreateEditReminderModal from '../CommonComps/Modals/CreateEditReminderModal';

const CreateReminderAction = () => {
  // integration of react hooks here
  const [showModal, setShowModal] = useState<boolean>(false);

  // rendering create reminder action component here
  return (
    <div>
      <AcademiaButton
        type='button'
        onClick={() => setShowModal(true)}
        variant='info'
        icon={<TbSquareRoundedPlusFilled className='size-6' />}
      >
        Create Reminder
      </AcademiaButton>

      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showModal && (
          <CreateEditReminderModal
            title='create'
            handleModalClose={() => setShowModal(false)}
          />
        )}
      </AnimatePresence>
    </div>
  );
};

export default CreateReminderAction;
